import { render, staticRenderFns } from "./upgradeVersion.vue?vue&type=template&id=451cb262&scoped=true&"
import script from "./upgradeVersion.vue?vue&type=script&lang=js&"
export * from "./upgradeVersion.vue?vue&type=script&lang=js&"
import style0 from "./upgradeVersion.vue?vue&type=style&index=0&id=451cb262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451cb262",
  null
  
)

export default component.exports